export enum EdiQuoteLinkMode {
    LINK = 'LINK',
    UPDATE = 'UPDATE',
    REJECT = 'REJECT'
}